import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "caption" }

import { useCssModule, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'base-alert',
  props: {
    type: {},
    size: { default: 'm' },
    align: { default: 'center' }
  },
  setup(__props: any) {



const css = useCssModule();

const computedClass = computed(() => {
  return {
    [css.container]: true,
    [css[`type-${__props.type}`]]: true,
    [css[`size-${__props.size}`]]: true,
    [css[`align-${__props.align}`]]: true
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(computedClass.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.left),
      "data-qa": "alert-left"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.icon),
        "data-qa": "icon"
      }, [
        _renderSlot(_ctx.$slots, "icon")
      ], 2),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.right),
      "data-qa": "alert-right"
    }, [
      _renderSlot(_ctx.$slots, "right")
    ], 2)
  ], 2))
}
}

})